module.exports = __webpack_public_path__ + "img/GradingPlans.df184e9c.svg";